"use client";

import React from "react";
import styled from "styled-components";
import Callout from "@churchofjesuschrist/eden-callout";
import { backgroundColorHover, borderColorPrimary, borderColorSecondary, spacing4, spacing8, spacing16 } from "@churchofjesuschrist/eden-style-constants";
import { Fade, Scrollable } from "@churchofjesuschrist/eden-fade";
import Footer from "./components/Footer";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const StyledCallout = styled(Callout).withConfig({
  componentId: "sc-80kb9u-0"
})(["width:100%;max-width:17.5rem;max-height:min(37.5rem,100vh);display:flex;flex-direction:column;& hr{height:1px;background-color:", ";border:none;margin:0;}&&& label{display:flex;padding:calc(", " + ", ") ", ";justify-content:space-between;input{margin-inline-start:auto;}&:hover{background:", ";cursor:pointer;}}&&& fieldset{display:block;padding-block-end:", ";& legend{display:block;width:100%;padding:calc(", " + ", ") ", " ", ";&::after{content:\"\";display:block;width:100%;border-bottom:1px solid ", ";}}& label{justify-content:flex-start;}& button{display:block;width:100%;padding:calc(", " + ", ") ", ";font-size:14px;text-align:start;&:hover{text-decoration:underline;}}}& input:is([type=\"checkbox\"],[type=\"radio\"]){cursor:pointer;}"], borderColorPrimary, spacing8, spacing4, spacing16, backgroundColorHover, spacing16, spacing8, spacing4, spacing16, spacing8, borderColorSecondary, spacing8, spacing4, spacing16);

/**
 * Use a contextual menu to display a list of links/actions that can be toggled on/off. While similar to [eden-callout](/components/eden-callout), this component adds styling to accommodate [eden-form-parts](/components/eden-form-parts).
 * @param {object} props - The component props
 * @param {object} props.forRef - The ref to which the contextual menu belongs*
 * @param {React.ReactNode} props.children - Content inside the contextual menu
 * @param {boolean} [props.open] - Whether the contextual menu is open
 * @param {Function} [props.onClickOutside] - Handler for when a click occurs outside of the contextual menu (e.g., to close the callout)
 * @param {React.ReactNode} [props.footer] - Content to embed in the footer of the contextual menu
 * @returns {React.ReactNode} The contextual menu component
 */
const ContextualMenu = ({
  forRef,
  children,
  open,
  onClickOutside,
  footer,
  ...props
}) => {
  return /*#__PURE__*/_jsxs(StyledCallout, {
    forRef: forRef,
    open: open,
    onClickOutside: onClickOutside,
    ...props,
    children: [/*#__PURE__*/_jsx(Fade, {
      children: /*#__PURE__*/_jsx(Scrollable, {
        children: children
      })
    }), footer ? /*#__PURE__*/_jsx(Footer, {
      children: footer
    }) : null]
  });
};
ContextualMenu.displayName = "ContextualMenu";
export default ContextualMenu;